import { useEffect, useState } from 'react';
import { APP_DISPLAY_NAME, DEFAULT_LANGUAGE } from '../../../config/app';
import { useTranslation } from '../../../i18n/index';
import { AppLogo } from '../../components/AppLogo';
import s from './Splash.module.scss';

function buildSplashNumberRun(length = 6): string[] {
  const seq: string[] = [];
  while (seq.length < length) {
    const next = String(Math.floor(Math.random() * 100)).padStart(2, '0');
    if (seq[seq.length - 1] === next) continue;
    seq.push(next);
  }
  return seq;
}

export function Splash({ lang = DEFAULT_LANGUAGE }: { p?: unknown; lang?: string }) {
  const t = useTranslation(lang);
  const [n, setN] = useState('00');

  useEffect(() => {
    const seq = buildSplashNumberRun();
    let i = 0;
    const id = setInterval(() => {
      if (i < seq.length) { setN(seq[i]); i++; }
      else clearInterval(id);
    }, 180);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={s.splash}>
      <div className={`drift ${s.glow}`} />

      <div className={s.content}>
        <div className={s.logoWrap}>
          <AppLogo variant="mark" height={56} />
        </div>

        <div className={s.range}>▸ 00 — 99</div>

        <div className={s.number}>{n}</div>

        <div className={s.appName}>{APP_DISPLAY_NAME}</div>

        <div className={s.tagline}>{t.appTagline}</div>
      </div>
    </div>
  );
}
